
import AMoney from './AMoney.vue';

export default {
  components: { AMoney },

  props: {
    amount: {
      type: String,
      required: true,
    },
  },
};
